
<template>
  <div
    class="pageExchange"
    ref="exchange"
  >
    <bCardHeader
      :param="param"
      class="card-header"
      :buttons="buttons"
    ></bCardHeader>
    <el-row
      class="row-wrap"
      :gutter="30"
    >
      <el-col
        :xs="24"
        :sm="24"
        :md="12"
        :lg="12"
        :xl="12"
        class="p0"
      >
        <div class="card-base card-shadow--small fund-transfer left-card">
          <div class="exchange-title">{{$t('exchange.exchangeTitle')}}</div>
          <el-form
            ref="ruleForm"
            :rules="rules"
            :model="ruleForm"
            label-position="top"
            label-width="80px"
            class="demo-ruleForm"
            v-loading="loadingForm"
          >
            <el-form-item :label="$t('exchange.exchangeDirection')">
              <span class="convert-currency">
                <img :src="fromCurrency.icon" alt="">
                <span> {{fromCurrency.name}} </span>
                <span v-if="selectLang !== 'en'">
                  <span class="split-line">|</span>
                  <span> {{fromCurrency.value}} </span>
                </span>
              </span>
              <img src="@/assets/images/convert.png"
                   class="convert-icon"
                   @click="changeCurrrency"
                   alt=""
                   >
              <span class="convert-currency">
                <img :src="toCurrency.icon" alt="">
                <span> {{toCurrency.name}}  </span>
                <span v-if="selectLang !== 'en'">
                  <span class="split-line">|</span>
                  <span> {{toCurrency.value}} </span>
                </span>
              </span>
            </el-form-item>
            <el-form-item
              :label="$t('exchange.accountNumberTitle')"
              prop="tradeAccount"
            >
              <bAccountNumbersSelect
                ref="accountList"
                v-model="ruleForm.tradeAccount"
                :accountNumberList="tradeAccountSelect"
                @change="getAccountNumber"
                :isClear="isClear"
                type="exchange"
              ></bAccountNumbersSelect>
            </el-form-item>
            <!-- 兑出金额 -->
            <el-form-item
            :label="$t('exchange.cashOut')"
              prop="fromAmount"
            >
              <el-input
                placeholder=""
                v-model="ruleForm.fromAmount"
                class="input_aomut"
                @input="inputFromAmount"
                @blur="blurFromAmount"
              >
                <template slot="prepend">
                  {{fromCurrency.value}}
                </template>
                <div slot="append" class="exchangeAll" @click="exchangeAll">
                    {{$t('exchange.exchangeAll')}}
                </div>
                <div
                  slot="prefix"
                  class="money-icon"
                >{{fromCurrencyIcon}}</div>
              </el-input>
              <div class="lock-tips"  v-show="isLockFrom">
                <img src="@/assets/images/icon_tishi.png" alt="" @click="showTips('out')">
                <span class="lock-text">
                  {{$t('exchange.lockOut')}}
                </span>
              </div>
            </el-form-item>
            <div class="explain" v-loading="isRefresh">
              <!-- 可兑换金额 -->
              <div class="mb-12">
                <span class="mr-18">{{$t('exchange.swapLines')}}</span>
                <span class="right-text">
                  <span class="amount">{{currencyObj[fromCurrency.value] || '0.00'}} </span>{{$t(`common.${(fromCurrency.value).toLowerCase()}`)}}
                </span>
              </div>
              <!-- 参考汇率 -->
              <div >
                <span class="mr-18">{{$t('exchange.referenceRate')}}</span>
                <span class="right-text">
                  <span>{{ fromCurrency.value === "USD" ? 1 : ruleForm.exchangeRate }}</span>
                  <span>{{ fromCurrency.name }} </span>
                  <span> ≈ </span>
                  <span> {{ fromCurrency.value === "HKD" ? 1 : ruleForm.exchangeRate }}</span>
                  <span>{{ toCurrency.name }}</span>
                </span>
                <img @click="getExchangeRate"
                     src="@/assets/images/icon_refresh.png"
                     alt=""
                     class="refresh-icon">

              </div>
            </div>
            <!-- 兑入金额 -->
            <el-form-item
              :label="$t('exchange.cashIn')"
              prop="toAmount"
            >
              <el-input
                placeholder=""
                v-model="ruleForm.toAmount"
                @input="inputToAmount"
                class=""
                @blur="blurToAmount"
              >
                <template slot="prepend">
                  {{toCurrency.value}}
                </template>
                <div
                  slot="prefix"
                  class="money-icon"
                >{{fromCurrencyIcon}}</div>
              </el-input>
              <div class="lock-tips" v-show="isLockTo" >
                <img src="@/assets/images/icon_tishi.png" alt="" @click="showTips('in')">
                <span class="lock-text">
                  {{$t('exchange.lockIn')}}
                </span>
              </div>
            </el-form-item>
            <el-form-item class="text-center">
              <el-button
                class="submit-primary-btn"
                type="primary"
                @click="submitFn('ruleForm')"
              >
                {{$t('withdrawal.button_submit')}} </el-button>
            </el-form-item>
            <div class="tips" v-html="$t('exchange.info')">
            </div>
          </el-form>
        </div>
      </el-col>
      <el-col
        :xs="24"
        :sm="24"
        :md="12"
        :lg="12"
        :xl="12"
        class="p0 withdrawal-records"
        v-loading="loadingThreeList"
      >
        <bThreeList
          :params="parentList"
          listTitle="WITHDRAWAL"
          :src='src'
          :router="router"
          :text="$t('exchange.noExchange')"
        ></bThreeList>
      </el-col>
    </el-row>
    <!-- 撤销弹窗 -->
    <!-- <bCancelDialog :dialogVisible.sync="isCancelShow" type="withdrawal" :closeModal="closeModal" :loading.sync="loadingSub" :handle="cancelExchange"></bCancelDialog> -->
    <!-- 获取申请码弹窗 -->
    <bDialog
      :dialogVisible.sync="isCodeShow"
      @closeChange="closeChange"
      :params="dialogParams"
      :closeModal="closeModal"
      :component="componentDialog1"
      :contiune="contiune"
      :showClose="showClose"
    ></bDialog>
    <bPreviewDialog
      :handle="createExchange"
      :params="previewForm"
      :loading="loadingPreviewDialog"
      :closeModal="closeModal"
      :dialogVisible.sync="dialogVisible"
    ></bPreviewDialog>
    <el-dialog class="error-dialog"
                  :visible.sync="spdialogOpen"
                  :title="$t('logout.tips')"
                  width="30%">
                  <div>{{$t('common.spInfo')}}</div>
                  <div slot="footer" class="footer-box">
                    <el-button style="width:40%;margin-left:0;" type="primary" @click="spdialogOpen=false">{{$t('common.ok')}}</el-button>
                  </div>
     </el-dialog>
     <el-dialog
                :visible.sync="popupVisible"
                width="30%"
                class="fund-box"
                :before-close="toContinue"
                :close-on-click-modal="false">
      {{$t('common.dormantDetailTip')}}
      <div class="btn-box btn-box-one">
        <div class="top"
              @click="toContinue">{{$t('common.knowIt')}}</div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import complete1 from '../fund-transfer/info-dialog.vue'
import { mapGetters, mapState } from 'vuex'
import { multiply } from '@/util/mathUtil'
import api from '@/api/v2/exchangeRate'
import api1 from '@/api/v2/trade'
import moment from 'moment'
export default {
  data () {
    // let checkInputAccountNum = (rule, value, callback) => {
    //   if (!value) {
    //     callback(new Error(this.$t('exchange.selectTradeAccountTips')))
    //   } else {
    //     callback()
    //   }
    // }
    let checkSwapAmount = (rule, value, callback) => {
      let reg = /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/
      // value = this.Util.rmoney(value)
      let swapLines = this.currencyObj[this.fromCurrency.value]
      if (swapLines) {
        swapLines = this.Util.rmoney(swapLines)
      } else {
        swapLines = 0
      }
      let flag = reg.test(value)
      let flag2 = value > 0 && value <= swapLines
      if (!value) {
        this.isLockFrom = false
        this.isLockTo = false
        callback(new Error(this.$t('exchange.inputSwapAmountTips')))
      } else if (value < 0) {
        this.isLockFrom = false
        this.isLockTo = false
        callback(new Error('金额须大于0.01'))
      } else if (!flag) {
        this.isLockFrom = false
        this.isLockTo = false
        callback(new Error(this.$t('exchange.tips.10001')))
      } else if (!flag2) {
        this.isLockFrom = false
        this.isLockTo = false
        callback(new Error(this.$t('exchange.tips.10002') + this.fmoney(swapLines)))
      } else {
        callback()
      }
    }

    return {
      text: 'noWithdrawal',
      src: require('@/assets/images/noWithdrawal.png'),
      componentDialog1: complete1, // 弹窗内容
      buttons: [],
      router: 'exchangeRecords',
      // isCancelShow: false,
      dialogVisible: false,
      param: {
        title: 'exchange',
        links: [{ title: 'home' }, { title: 'exchange' }]
      },
      closeModal: false,
      orderId: '',
      params: {
        orderId: ''
      },
      ruleForm: {
        tradeAccount: '',
        tradeAccountType: '',
        fromCurrency: 'HKD',
        toCurrency: 'USD',
        exchangeRate: '',
        fromAmount: '',
        toAmount: ''
        // swapLines: '0.00',
        // swapAmount: ''
      },
      previewForm: {},
      rules: {
        // tradeAccount: [
        //   { require: true, validator: checkInputAccountNum, trigger: 'change' }
        // ],
        fromAmount: [
          { require: true, validator: checkSwapAmount, trigger: 'change' }
        ]
        // toAmount: [
        //   { require: true, validator: checkToAmount, trigger: 'change' }
        // ]
      },
      tradeAccountSelect: [],
      fromCurrencyIcon: '',
      loadingPreviewDialog: false,
      contiune: true, // 继续按钮
      showClose: false, // 关闭小图标
      isCodeShow: false,
      loadingForm: false,
      loadingThreeList: false,
      // currencyOption: [],
      lastExchangeRate: '',
      balanceObj: '',
      parentList: [],
      uptradeAccountType: '',
      isClear: false,
      fromCurrency: {
        name: this.$t('common.hkd'),
        value: 'HKD',
        icon: require('@/assets/images/img_hk.png')
      },
      toCurrency: {
        name: this.$t('common.usd'),
        value: 'USD',
        icon: require('@/assets/images/img_us.png')
      },
      formCurrencyMap: {},
      currencyObj: {},
      isLockFrom: false,
      isLockTo: false,
      isRefresh: false,
      spdialogOpen: false,
      isDormant: false,
      popupVisible: false

    }
  },
  computed: {
    ...mapGetters([
      'getUser',
      'valueAccountNumber',
      'getClientProfile',
      'getAccountInfo',
      'selectLang'
    ]),
    ...mapState(['userInfo', 'filterSPTradingAccountList']),
    dialogParams () {
      return { orderId: this.orderId }
    }
  },
  watch: {
  },
  created () {

  },
  async mounted () {
    // 仅有sp账户
    if (this.userInfo.isSPAccount === 'Y' && !this.filterSPTradingAccountList.length) {
      return (this.spdialogOpen = true)
    }
    const account = this.$refs.accountList.tradeAccount
    this.isDormant = this.$refs.accountList.isDormant
    this.uptradeAccountType = this.$refs.accountList.accountType
    this.ruleForm.tradeAccountType = this.uptradeAccountType
    if (this.$refs.accountList.tradeType !== 'STOCK' && this.$refs.accountList.tradeType !== 'FUND') {
      this.getTradeAccountBalance(account, this.uptradeAccountType)
    } else {
      this.getNewBalance(account, this.uptradeAccountType)
    }
    await this.getExchangeRate()
    this.getExchangeRecord()
  },
  methods: {
    fmoney(s, n) {
      n = n > 0 && n <= 20 ? n : 2
      s = +s
      return (s.toFixed(n) + '').replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,')
    },
    inputFromAmount (val) {
      if (val) {
        let filerVal = val.toString().match(/^\d*(\.?\d{0,2})/g) || [] // 只能输入两位小数
        let realVal = filerVal[0].replace(/0*(\d+)/, '$1') // 不能以0开始 例如012
        this.$nextTick(() => {
          this.ruleForm.fromAmount = realVal
          if (realVal && this.fromCurrency.value === 'HKD') {
            this.ruleForm.toAmount = (parseInt((this.ruleForm.fromAmount / this.ruleForm.exchangeRate) * 100) / 100).toFixed(2)
          } else if (realVal && this.fromCurrency.value === 'USD') {
            this.ruleForm.toAmount = (parseInt(this.ruleForm.fromAmount * this.ruleForm.exchangeRate * 100) / 100).toFixed(2)
          }
        })
      } else {
        this.ruleForm.toAmount = ''
      }
    },
    inputToAmount(val) {
      if (val) {
        let filerVal = val.toString().match(/^\d*(\.?\d{0,2})/g) || [] // 只能输入两位小数
        let realVal = filerVal[0].replace(/0*(\d+)/, '$1') // 不能以0开始 例如012
        this.$nextTick(() => {
          this.ruleForm.toAmount = realVal
          if (realVal && this.fromCurrency.value === 'HKD') {
            this.ruleForm.fromAmount = (
              parseInt(this.ruleForm.toAmount * this.ruleForm.exchangeRate * 100) / 100
            ).toFixed(2)
          } else {
            this.ruleForm.fromAmount = (
              parseInt((this.ruleForm.toAmount / this.ruleForm.exchangeRate) * 100) / 100
            ).toFixed(2)
          }
        })
      } else {
        this.ruleForm.fromAmount = ''
      }
    },
    // 去千分符
    // delcommafy (num) {
    //   // eslint-disable-next-line eqeqeq
    //   if (((num + '').trim()) == '') {
    //     return ''
    //   }
    //   num = num.replace(/,/gi, '')
    //   console.log(3333333, num)
    //   return Number(num)
    // },
    changeCurrrency () {
      let temp = JSON.parse(JSON.stringify(this.fromCurrency))
      this.fromCurrency = JSON.parse(JSON.stringify(this.toCurrency))
      this.toCurrency = temp

      this.ruleForm.exchangeRate = this.fillZero(
        this.formCurrencyMap[this.fromCurrency.value]
      )

      this.resetForm('ruleForm')
      this.ruleForm.fromCurrency = this.fromCurrency.value
      this.ruleForm.toCurrency = this.toCurrency.value
      console.log(this.ruleForm.fromCurrency, this.ruleForm.toCurrency)
    },
    resetForm (formName) {
      this.ruleForm.fromAmount = ''
      this.ruleForm.toAmount = ''
      // this.isClear = true
      this.isLockFrom = false
      this.isLockTo = false
    },
    tradeAccountConfig (tradeAccountType) {
      return this.Util.getTradeAccountConfig(tradeAccountType)
    },
    async getExchangeRecord () {
      try {
        this.loadingThreeList = true
        let res = await api.getExchangeRecords()
        let arr = []
        res.data.forEach(item => {
          let obj = {}
          obj.applyTime = moment(item.createdDate).format('YYYY-MM-DD HH:mm:ss')
          obj.status = item.status
          obj.orderId = item.orderId
          obj.childList = {
            accountNo: item.tradeAccountNumber,
            exchangeAmountapply: item.exchangeAmount ? (item.exchangeCurrency + ' ' + this.fmoney(item.exchangeAmount)) : '--',
            lockWay: item.lockWay === 'IN' ? this.$t('exchange.lockIn') : this.$t('exchange.lockOut'),
            applyTime: moment(item.createdDate).format('YYYY-MM-DD HH:mm:ss'),
            exchangeRealAmount: item.realAmount ? (item.realCurrency + ' ' + this.fmoney(item.realAmount)) : '--',
            realExchangeRate: item.realExchangeRate || '--',
            businessId: item.businessIdRemark
          }
          if (item.status === 'FAILURE') {
            obj.remark = item.remarkmultiply
          }
          if (item.status !== 'COMPLETED') {
            delete obj.childList.exchangeRealAmount
            delete obj.childList.realExchangeRate
          }
          arr.push(obj)
        })
        this.parentList = arr.slice(0, 3)
        this.loadingThreeList = false
      } catch (error) {
        this.loadingThreeList = false
        console.log('>>>error', error)
      } finally {
        this.loadingThreeList = false
      }
    },
    /**
     * 获取最新汇率记录
     */
    async getExchangeRate () {
      try {
        this.isRefresh = true
        this.ruleForm.tradeAccount = this.$refs.accountList.tradeAccount
        let data = { params: {
          tradeAccountNumber: this.ruleForm.tradeAccount,
          tradeAccountType: this.uptradeAccountType
        } }
        let res = await api.getExchangeRate(data)
        this.lastExchangeRate = res.data
        setTimeout(() => {
          this.isRefresh = false
        }, 500)
        const sellRate = res && res.data ? res.data.usd.sell : 0
        const buyRate = res && res.data ? res.data.usd.buy : 0
        const formCurrencyMap = {
          HKD: sellRate,
          USD: buyRate
        }
        this.formCurrencyMap = formCurrencyMap
        this.ruleForm.exchangeRate = this.fillZero(
          this.formCurrencyMap[this.fromCurrency.value]
        )
      } catch (error) {
        this.isRefresh = false
        let message = this.$t('exchange.errMsg.10001')
        this.$message({
          showClose: true,
          message: message,
          type: 'error'
        })
      }
    },

    fillZero(val) {
      val = val + ''
      if (val.indexOf('.') < 0) {
        val = val + '.00000'
      } else {
        let decimalLen = 5 - val.split('.')[1].length
        console.log(decimalLen, 'decimalLen')
        for (let i = 0; i < decimalLen; i++) {
          val = val + '0'
        }
      }
      return val
    },
    getSwapLines (cashList) {
      let currencyArr = ['HKD', 'USD', 'CNY']
      let currencyObj = {}
      currencyArr.map((item) => {
        // let flag = false
        let balance = 0
        cashList.map((el) => {
          if (el.currency === item) {
            // flag = true
            balance = el.amount
          }
        })
        currencyObj[item] = this.fmoney(multiply(balance, 1).toFixed(2))
      })
      this.currencyObj = currencyObj
    },
    async getAccountNumber (tradeAccountObj) {
      console.log(tradeAccountObj, 'tradeAccountObj')
      this.isDormant = tradeAccountObj.isDormant
      try {
        this.resetForm('ruleForm')
        // this.isClear = false
        this.ruleForm.tradeAccount = tradeAccountObj.value
        console.log(this.tradeAccountConfig(tradeAccountObj.tradeAccountType), 'this.tradeAccountConfig(tradeAccountObj.tradeAccountType)')
        if (!this.tradeAccountConfig(tradeAccountObj.tradeAccountType)['isTradeAccountExit']
        ) {
          // eslint-disable-next-line no-throw-literal
          throw { code: '5003', msg: 'tradeAccountType is lost' }
        }
        this.loadingForm = true
        this.ruleForm.tradeAccountType = tradeAccountObj.tradeAccountType
        this.uptradeAccountType = tradeAccountObj._tradeAccountType
        if (tradeAccountObj.type !== 'STOCK' && tradeAccountObj.type !== 'FUND') {
            await this.getTradeAccountBalance(
            tradeAccountObj.value,
            tradeAccountObj._tradeAccountType
          )
        } else {
          this.getNewBalance(tradeAccountObj.value, tradeAccountObj._tradeAccountType)
        }
      } catch (error) {
        this.loadingForm = false
        console.log('>>>>error', error)
        let message = this.$t(`errMessage.11000`)
        this.$message({
          showClose: true,
          message: message,
          type: 'error'
        })
      } finally {
        this.loadingForm = false
      }
    },
    async getTradeAccountBalance (val, tradeAccountType) {
      try {
        const result = await api1.getUserBalance({
          tradeAccountNumber: val,
          tradeAccountType
        })
        if (!result.data) {
            let message = this.$t(`errMessage.11000`)
            this.$message({
              showClose: true,
              message: message,
              type: 'error'
            })
          }
          this.balanceObj = result.data
          this.loadingForm = false
          this.getSwapLines(this.balanceObj)
      } catch (error) {
        throw error
      }
    },

    submitFn (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.previewForm.tradeAccount = this.$t(`tradeAccountType.${this.uptradeAccountType}`) + ' | ' + this.ruleForm.tradeAccount
          this.previewForm.exchangeCurrency =
          `${this.ruleForm.fromCurrency} | ${this.$t(`common.${this.ruleForm.fromCurrency.toLowerCase()}`)}
          ${this.$t('common.exhangeTo')}
          ${this.ruleForm.toCurrency} | ${this.$t(`common.${this.ruleForm.toCurrency.toLowerCase()}`)}`
          this.previewForm.exchangeRate = this.ruleForm.exchangeRate
          this.previewForm.swapAmount = this.ruleForm.fromCurrency + ' | ' + this.fmoney(this.ruleForm.fromAmount)
          if (this.isDormant) {
            this.popupVisible = true
            return
          }
          this.dialogVisible = true
        } else {
          console.log('error')
          return false
        }
      })
    },
    toContinue() {
      this.popupVisible = false
      this.dialogVisible = true
    },
    async createExchange () {
      try {
        this.loadingPreviewDialog = true
        let createPramas = {
          exchangeAmount: this.Util.rmoney(this.ruleForm.fromAmount), // 兑换金额
          exchangeCurrency: this.ruleForm.fromCurrency,
          fromCurrency: this.ruleForm.fromCurrency, // 被兑换货币
          submitSource: 'CP_WEB',
          toCurrency: this.ruleForm.toCurrency, // 兑换货币
          tradeAccountNumber: this.ruleForm.tradeAccount, // 交易账号号码
          tradeAccountType: this.uptradeAccountType, // 交易账号类型
          toAmount: this.Util.rmoney(this.ruleForm.toAmount),
          exchangeRate: this.ruleForm.exchangeRate,
          lockWay: this.isLockTo ? 'IN' : 'OUT' // 锁定兑出兑入
        }
        let res = await api.commitExchange(createPramas)
        if (res) {
          this.orderId = res.data.orderId
          this.isCodeShow = true
          this.loadingPreviewDialog = false
          this.dialogVisible = false
          this.closeModal = false
        }
      } catch (error) {
        this.loadingPreviewDialog = false
        this.dialogVisible = false
        this.isCodeShow = false
        this.closeModal = false
        this.$message.error(error.msg)
        console.log('>>>>error', error)
      }
    },
    closeChange () {
      this.getExchangeRecord()
      this.resetForm('ruleForm')
    },
    exchangeAll () {
      this.ruleForm.fromAmount = this.currencyObj[this.fromCurrency.value] ? this.Util.rmoney(this.currencyObj[this.fromCurrency.value]) : 0
      const toAmount = this.ruleForm.fromAmount && (parseInt((this.ruleForm.fromAmount / this.ruleForm.exchangeRate) * 100) / 100).toFixed(2)
      this.ruleForm.toAmount = toAmount
      this.isLockFrom = true
      // this.formatMoney()
    },
    showTips (type) {
      if (type === 'out') {
        this.$msgbox({
          title: this.$t('exchange.lockOut'),
          message: this.$t('exchange.lockOutTips'),
          showCancelButton: false,
          showConfirmButton: false,
          customClass: 'lock-msg'
        })
      } else {
        const h = this.$createElement
        this.$msgbox({
          title: this.$t('exchange.lockIn'),
          showCancelButton: false,
          showConfirmButton: false,
          dangerouslyUseHTMLString: true,
          customClass: 'lock-msg',
          message: h('div', null, [
            h('p', null, this.$t(`exchange.lockInTips`)),
            h('h3', { style: 'font-size:18px;color:#182A54;font-weight:300' }, this.$t(`exchange.example1`)),
            h('p', { domProps: { innerHTML: this.$t(`exchange.exampleTip1`) } }),
            h('h3', { style: 'font-size:18px;color:#182A54;font-weight:300' }, this.$t(`exchange.example2`)),
            h('p', { domProps: { innerHTML: this.$t(`exchange.exampleTip2`) } })
          ])
        })
      }
    },
    blurFromAmount () {
      if (this.ruleForm.fromAmount) {
        this.isLockFrom = true
        this.isLockTo = false
      } else {
        this.isLockFrom = false
      }
    },
    blurToAmount() {
      if (this.ruleForm.toAmount) {
        this.isLockTo = true
        this.isLockFrom = false
      } else {
        this.isLockTo = false
      }
    },
    async getNewBalance(val, type) {
      console.log(val, 'val>>>>>>>>>>>>>')
      let params = {
        tradeAccount: val,
        accountType: type
      }
      let res = await api1.getNewBalance(params)
      this.loadingForm = false
      if (res && res.code === 200) {
        this.balanceObj = res.data.map(item => {
          return {
            ...item,
            amount: Number(item.availableBalance)
          }
        })
        this.getSwapLines(this.balanceObj)
      }
    }
  }
}
</script>
<style lang="scss">
.pageExchange {
  height: min-content;
  margin-top: 0;
  .error-dialog{
    .footer-box{
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    .el-dialog__header{
      text-align: center;
      font-weight: 600;
    }
  }
  .checkboxTips {
    margin: 20px auto;
    padding-left: 2%;
    .el-checkbox__input {
      vertical-align: baseline;
    }
    .el-checkbox__label {
      font-size: 18px;
    }
  }
  .depositReciepTips {
    width: 96%;
    background: #f4f4f4;
    border-left: 3px solid #fec000;
    padding: 2%;
    margin-top: 10px;
    p {
      margin: 0;
      line-height: 20px;
    }
    .ReciepTipsTitle {
      font-size: 20px;
      font-weight: 600;
    }
  }
  .fund-transfer {
    background: #fff;
    // margin: 30px;
    padding: 20px 30px 86px 30px;
  }

  .exchange-title {
    border-bottom: 4px solid #e2e2e2;
    margin: 0 0 20px;
    padding-bottom: 20px;
    font-weight: 600;
    color: #182a54;
    font-size: 18px;
    font-family: Muli-Bold;
  }
  .el-input__inner {
    padding-left: 10px !important;
  }
  .el-input-group__prepend {
    font-family: Muli-Bold;
    font-size: 14px;
    color: #23282e;
    // letter-spacing: 0.17px;
    background: #F3F4F6;
    position: relative;
  }

  .el-select .el-input .el-select__caret {
    font-weight: bold;
    color: #fec000;
  }

  .money-icon {
    height: 45px;
    line-height: 45px;
    font-family: Muli-Bold;
    padding: 0px 5px;
    font-size: 14px;
    color: #000000;
    letter-spacing: 0.17px;
  }
  .input_aomut .el-input__inner {
    padding-left: 40px;
    // border-right: none;
  }
  .el-input.is-disabled .el-input__inner {
    background-color: #e2e2e2;
    color: #000000;
  }
  .submit-primary-btn {
    color: #192b57;
    width: 15rem;
    height: 3.5rem;
    margin-top: 20px;
    span {
      font-family: Muli-Bold;
      font-size: 14px;
      color: #193060;
      letter-spacing: 0.17px;
      text-align: center;
    }
  }

  .records-list-tree {
    margin-top: 0px;
    padding: 0 20px 10px;
  }

  hr {
    border: 2px solid #eee;
    margin: 20px 0;
  }

  .el-select {
    width: 100%;
  }

  .left-card {
    margin-left: 0rem !important;
    margin-right: 0rem !important;
  }
  .convert-currency {
    width: 45%;
    display: inline-block;
    border: 1px solid #E2E2E2;
    border-radius: 5px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #24282D;
    img {
      margin-left: 16px;
      margin-right: 10px;
      vertical-align: sub;
    }
  }
  .convert-icon {
    margin-left: 24px;
    margin-right: 24px;
    vertical-align: middle;
  }
  .explain {
    width: 100%;
    height: 86px;
    background: #F3F4F6;
    padding: 20px 30px;
    box-sizing: border-box;
    border-left: 4px solid #FEC000;
    color: #666666;
    font-size: 12px;
    .right-text {
      color: #333333;
      margin-right: 8px;
    }
    .amount {
      color: #E58D15;
    }
    .refresh-icon {
      vertical-align: text-top;
    }
  }
  .mb-12 {
    margin-bottom: 12px;
  }
  .ml-18 {
    margin-right: 18px;
  }
  .text-center {
    margin-bottom: 40px;
  }
  .tips {
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    line-height: 17px;
  }

  .el-input-group__append{
    background: #fff;
    border: none;
    position: absolute;
    color: #3773E1;
    right: 65px;
    bottom: 10px;
  }
  .lock-tips {
    img {
      margin-right: 3px;
    }
    .lock-text {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #EE4845;
    }
  }
}
.lock-msg {
  .el-message-box__title span{
    font-size: 18px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #182A54;
  }
  .el-message-box__message p{
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #7D7D7D;
  }
}
@media (max-width: 768px) {
  .layout-container .container .view {
    max-width: 100%;
    padding: 0 !important;
    margin: 0 !important;
  }
  .row-wrap {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
  .p0 {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  .withdrawal-records {
    margin-top: 20px;
  }
}
.btn-box-one {
  padding-top: 30px;
  .top {
    margin-bottom: 0;
  }
}
.btn-box {
  font-size: 14px;
  font-weight: 600;
  color: #193060;
  line-height: 20px;
  width: 120px;
  margin: auto;
  text-align: center;

  .top {
    background: #fec000;
    border-radius: 5px;
    padding: 15px 0;
    margin-bottom: 20px;
    cursor: pointer;
  }
  .bottom {
    border-radius: 5px;
    border: 1px solid #193060;
    padding: 15px 0;
    cursor: pointer;
  }
}
</style>
